import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WorkflowRoutingService } from './services/flow-Routing.service';
import { FlowAccountService } from './services/flow-account.service';
import { NavigationEnd, Router } from '@angular/router';
import { VexSplashScreenService } from '@vex/services/vex-splash-screen.service';
import { NavigationLoaderService } from '@vex/core/navigation/navigation-loader.service';
import { NavigationSubheading } from '@vex/core/navigation/navigation-item.interface';
import { filter, Observable } from 'rxjs';
import { VexConfigService } from '@vex/config/vex-config.service';
import { VexConfig } from '@vex/config/vex-config.interface';
@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  config$: Observable<VexConfig>;
  constructor(private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private WorkflowRoutingService: WorkflowRoutingService,
    private flowAccountService : FlowAccountService,
    private navigationLoaderService: NavigationLoaderService,
    private splashScreenService: VexSplashScreenService,
    private configService: VexConfigService,
    private router: Router) {
      this.config$ = this.configService.config$;
Settings.defaultLocale = this.localeId;



if (this.platform.BLINK) {
this.renderer.addClass(this.document.body, 'is-blink');
}

this.matIconRegistry.addSvgIconResolver(
(
name: string,
namespace: string
): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
switch (namespace) {
case 'mat':
  return this.domSanitizer.bypassSecurityTrustResourceUrl(
    `assets/img/icons/material-design-icons/two-tone/${name}.svg`
  );

case 'logo':
  return this.domSanitizer.bypassSecurityTrustResourceUrl(
    `assets/img/icons/logos/${name}.svg`
  );

case 'flag':
  return this.domSanitizer.bypassSecurityTrustResourceUrl(
    `assets/img/icons/flags/${name}.svg`
  );
}
}
);
this.navigationLoaderService.addNavigationItem(this.favoritesRoutes);
this.navigationLoaderService.addNavigationItem(this.administrationRoutes);
this.navigationLoaderService.addNavigationItem(this.configurationRoutes);
this.navigationLoaderService.addNavigationItem(this.settingsRoutes);
} 

  private favoritesRoutes :NavigationSubheading =
  {
      type: 'subheading',
      label: 'Favorites',
      children: [ 
          {
              type: 'link',
              label: 'My tasks',
              route: 'favorites/tasks',
              icon: 'check-square',
              routerLinkActiveOptions: { exact: true }
          },
          {
              type: 'link',
              label: 'My workflows',
              route: 'favorites/activities',
              icon: 'play-circle'
          },
          {
              type: 'link',
              label: 'My notifications',
              route: 'favorites/notifications',
              icon: 'bell'
          }]
  };

  private administrationRoutes : NavigationSubheading = 
  {
      type: 'subheading',
      label: 'Administration',
      children: [
  {
      type: 'link',
      label: 'Dashboard',
      route: 'administration/dashboard',
      icon: 'grid'
  },
  {
      type: 'link',
      label: 'Templates',
      route: 'administration/templates',
      icon: 'cpu'
  },
  {
      type: 'link',
      label: 'Workflows',
      route: 'administration/workflows',
      icon: 'play-circle'
  },
 /* {
      type: 'link',
      label: 'Reports',
      route: 'reports',
      icon: 'bar-chart-2'
  }*/
]
}

  private configurationRoutes : NavigationSubheading = 
  {
      type: 'subheading',
      label: 'Configuration',
      children: [
      {
          type: 'link',
          label: 'Users',
          route: 'configuration/users',
          icon: 'user'
      },
      {
          type: 'link',
          label: 'Remote databases',
          route: 'configuration/databases',
          icon: 'cloud'
      },
    /*  {
          type: 'link',
          label: 'Settings',
          route: 'configuration/settings',
          icon: 'settings'
      }*/
  ]}

  private settingsRoutes: NavigationSubheading = {
    type: 'subheading',
    label: 'Settings',
    children: [
      {
        type: 'link',
        label: 'Email',
        route: 'settings/email',
        icon: 'mail'
      },
      {
        type: 'link',
        label: 'SLA',
        route: 'settings/sla',
        icon: 'file-text'
      }
    ]
  };

  ngOnInit() {
    this.flowAccountService.onAuthenticated().subscribe(value => {
      this.WorkflowRoutingService.configureWorkflowRoutes();
       });

       this.router.events
       .pipe(filter(event => event instanceof NavigationEnd))
       .subscribe((event: NavigationEnd) => {
         console.log('Navigation ended:', event);
         // Add your custom logic here
       });
  }



}
